import FilePickerViewState from '../store/schema/FilePickerViewState';
import { FilePickerViewType } from '../types/FilePickerViewSwitcher';
import { action } from 'satcheljs/lib/legacy';

export default action('changeUserPreferredViewType')(function changeUserPreferredViewType(
    viewType: FilePickerViewType,
    viewState: FilePickerViewState
) {
    viewState.userPreferredViewType = viewType;
});
